import { useMemo } from 'react';

import { useUserContext } from '@/modules/auth/hooks/useUser';
import { ArticlePerformanceFragment } from '@/modules/corporate/modules/article/graphql/fragments/generated/ArticlePerformance';
import { useFetchArticlePerformancesQuery } from '@/modules/corporate/modules/article/graphql/queries/generated/articlePerformance';

const useFetchPerformance = (entityIds: string[]) => {
  const users = useUserContext();
  const [{ fetching, data, error }] = useFetchArticlePerformancesQuery({
    variables: { filters: { entityIds, userIds: [users.id] }, first: entityIds.length },
    pause: !entityIds.length,
  });

  const contentPerformance = useMemo(
    () =>
      data?.contentPerformances.edges?.reduce(
        (acc, edge) => {
          const node = edge.node as ArticlePerformanceFragment;
          if (!node?.entityId) {
            return acc;
          }

          acc[node.entityId] = node;
          return acc;
        },
        {} as Record<string, ArticlePerformanceFragment>,
      ),
    [data?.contentPerformances.edges],
  );

  return { fetching, error, data: contentPerformance };
};

export default useFetchPerformance;
